import reducer from 'state/shipments/reducer';
import selectors from 'state/shipments/selectors';
import actions from 'state/shipments/actionCreators';
import types from 'state/shipments/actionTypes';
import effects from 'state/shipments/effects';

export { actions, selectors, effects, types };
export default reducer;
